/// <reference types="@capacitor/cli" />
export {};
//# sourceMappingURL=definitions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@codetrix-studio/capacitor-google-auth/dist/esm/definitions.js
// module id = 667
// module chunks = 112